import { Link } from "react-router-dom";

export default function ResourcesPage() {
  return <>
    <section className="pageHero"><div className="wrap">
      <p className="eyebrow">BREAKTHROUGH RESOURCES</p>
      <h1>Useful tools, videos and extras from Breakthrough.</h1>
      <p className="lead">The client portals stay where they belong in the navigation. This page is for the resources, education and tools Breakthrough has built over the years.</p>
    </div></section>
    <section className="section"><div className="wrap cards two">
      <article className="card big">
        <h2>Trench Life & Daily Tidbits</h2>
        <p>Short real-estate stories, lessons, motivation and practical ideas from the field. The original Daily Tidbits video library is still available here.</p>
        <Link className="btn navy" to="/trench-life">Watch Daily Tidbits</Link>
      </article>
      <article className="card big">
        <h2>Breakthrough Store</h2>
        <p>Breakthrough apparel, shirts, bottles and other BREPM gear from the original Redbubble store.</p>
        <a className="btn navy" href="https://www.redbubble.com/people/brepmgear/shop" target="_blank" rel="noreferrer">Visit the Redbubble Store</a>
      </article>
      <article className="card big">
        <h2>Market & Housing Insights</h2>
        <p>BREPM's Phoenix market analysis plus supplemental housing content from your paid Keeping Current Matters feed.</p>
        <Link className="btn navy" to="/insights">Read Market & Insights</Link>
      </article>
      <article className="card big">
        <h2>What Is My Home Worth?</h2>
        <p>Online estimates can be useful, but a real pricing review should account for the property, condition, location and current competing inventory.</p>
        <a className="btn navy" href="mailto:josh@brepm.com?subject=Home%20Value%20Review">Request a Home Value Review</a>
      </article>
    </div></section>
  </>;
}
